// src/lib/avatar.js
export function dicebearPng(seed, size = 128) {
  const s = encodeURIComponent(String(seed || "member"));
  // PNG endpoint works great with next/image
  return `https://api.dicebear.com/8.x/bottts/png?seed=${s}&size=${size}`;
}

export function getAvatarUrl({ profile, user, size = 128 } = {}) {
  // Prefer explicit URLs first (uploaded avatar or SSO photo)
  const direct = profile?.profilePictureUrl || user?.photoURL;
  if (direct) return direct;

  // Otherwise derive a stable seed
  const seed =
    profile?.username_lowercase ||
    profile?.username ||
    user?.displayName?.replace(/\s+/g, "").toLowerCase() ||
    user?.email?.split("@")[0] ||
    "member";

  return dicebearPng(seed, size);
}
